var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowCancelConfirm
    ? _c(
        "confirm",
        {
          staticClass: "small",
          attrs: {
            title: _vm.$t("walletQuota.withdrawalStaking"),
            closeIcon: false,
            showMask: true,
            leftBtnTxt: _vm.$t("walletQuota.confirm.cancel.leftBtn"),
            leftBtnClick: _vm.close,
            rightBtnTxt: _vm.$t("walletQuota.confirm.cancel.rightBtn"),
            rightBtnClick: _vm.submit
          }
        },
        [
          _c("div", { staticClass: "__row" }, [
            _c("div", { staticClass: "__row_t" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t("walletQuota.confirm.cancel.describe", {
                      amount: _vm.showStakingAmount
                    })
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__input_row __unuse_input" }, [
              _vm._v(_vm._s(_vm.showStakingAmount) + " dSLS")
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }